export default "__VITE_ASSET__27eeb9d3__"